import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import DialogTitleWithCloseButton from "../../../../components/DialogTitleWithCloseButton";
import { useState } from "react";
import AttachmentInput from "../../../../components/AttachmentInput";
import { errorToast } from "../../../../toast";
import { DOCUMENT_NAME } from "../../../../../../shared/constants";


export default function DocumentsModal(props) {

   const [ commissioningDoc, setCommissioningDoc ] = useState(null);
   const [ deliveryNote, setDeliveryNote ] = useState(null);
   const { onClose } = props;

   const save = () => {
      if (!commissioningDoc)
         return errorToast("Please select a commissioning document");
      if (!deliveryNote)
         return errorToast("Please select a delivery note");

      const attachments = [
         {
            ...commissioningDoc,
            name: DOCUMENT_NAME.INSTALLATION.COMMISSIONING_DOCUMENT,
         },
         {
            ...deliveryNote,
            name: DOCUMENT_NAME.INSTALLATION.DELIVERY_NOTE,
         }
      ];

      onClose(attachments);
   }

   return <Dialog open>
      <DialogTitleWithCloseButton onClose={onClose}>
         Documents
      </DialogTitleWithCloseButton>
      <DialogContent dividers>
         <div className="w-full max-w-[300px] flex flex-col gap-2">
            <AttachmentInput
               label="Commisioning Document"
               name={commissioningDoc?.name}
               onChange={setCommissioningDoc}
            />
            <AttachmentInput
               label="Delivery Note"
               name={deliveryNote?.name}
               onChange={setDeliveryNote}
            />
         </div>
      </DialogContent>
      <DialogActions>
         <Button variant="contained" onClick={save}>
            SAVE
         </Button>
      </DialogActions>
   </Dialog>
}